import { MapState, Source } from "@iventis/map-engine/src/types/store-schema";
import { initialState } from "@iventis/map-engine/src/state/map-state.initial-values";

export const initialMapState: MapState = {
    ...initialState.mapModule,
    position: {
        value: {
            lng: 0,
            lat: 0,
            zoom: 15,
            bearing: 0,
            pitch: 0,
            source: Source.HOST,
        },
        stamp: "",
    },
    layers: {
        value: [],
        stamp: "",
    },
};
